import { useCallback } from 'react'
import Dialog from '../../Common/Dialog/Dialog'
import DialogTitle from '../../Common/Dialog/DialogTitle'
import DialogContent from '../../Common/Dialog/DialogContent'
import DialogActions from '../../Common/Dialog/DialogActions'
import DialogButton from '../../Common/Buttons/DialogButton'
import { useTranslation } from 'react-i18next'
import { type UserImageStore } from '../../UserData/_stores/UserImageStore'
import { DeletePaginationItem } from '../../UserData/_actions/UserDataActions'
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch'
import { BatchDeleteImages, type BatchImageSelection } from '../../UserData/_actions/UserImageActions'
import { ClearImageSelectedImage } from '../../UIData/_actions/Account/AccountStoreActions'

type SingleImageProps = {
  image: UserImageStore
  selection?: never
  selectionCount?: never
}

type BatchImageProps = {
  image?: never
  selection: BatchImageSelection
  selectionCount: number
}

type Props = (SingleImageProps | BatchImageProps) & {
  opened: boolean
  onClose: () => void
}

export default function DeleteImageDialog(props: Props) {
  const dispatch = useAppDispatch()
  const [t] = useTranslation('account-v2')

  const onDelete = useCallback(() => {
    if (props.selection) {
      dispatch(BatchDeleteImages(props.selection).set({
        onSuccess: () => {
          dispatch(ClearImageSelectedImage())
        }
      }))

      props.onClose()
      return
    }

    const fd = new FormData()
    fd.append('id', props.image.get('id'))
    dispatch(DeletePaginationItem(fd, 'images'))

    props.onClose()
  }, [dispatch, props.image, props.onClose, props.selection])

  return <Dialog
    open={props.opened}
    maxWidth="xs"
    fullWidth
    onClose={props.onClose}
    showCloseButton
  >
    <DialogTitle>{props.selection
      ? t('Delete {{count}} images', { count: props.selectionCount })
      : t('Delete {{name}}', { name: props.image.get('name') })}</DialogTitle>
    <DialogContent>
      <p>{props.selection
        ? t('Are you sure that you want to delete the selected images?')
        : t('Are you sure that you want to delete this image?')}</p>
    </DialogContent>
    <DialogActions>
      <DialogButton
        color="secondary"
        onClick={props.onClose}
      >{t('Cancel')}</DialogButton>
      <DialogButton
        color="error"
        onClick={onDelete}
        autoFocus
      >{t('Delete')}</DialogButton>
    </DialogActions>
  </Dialog>
}
